import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Contact from "@/pages/Contact";
import Dashboard from "@/pages/Dashboard";
import ShipmentsList from "@/pages/ShipmentsList";
import ShipmentDetail from "@/pages/ShipmentDetail";
import ShipmentDocuments from "@/pages/ShipmentDocuments";
import NewShipment from "@/pages/NewShipment";
import Buyers, { NewBuyer } from "@/pages/Buyers";
import "@/index.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/app/*"
            element={
              <Protected>
                <AppShell>
                  <Routes>
                    <Route index element={<Dashboard />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="shipments" element={<ShipmentsList />} />
                    <Route path="shipments/new" element={<NewShipment />} />
                    <Route path="shipments/:id" element={<ShipmentDetail />} />
                    <Route path="shipments/:id/documents" element={<ShipmentDocuments />} />
                    <Route path="shipments/:id/documents/:docId" element={<ShipmentDocuments />} />
                    <Route path="buyers" element={<Buyers />} />
                    <Route path="buyers/new" element={<NewBuyer />} />
                    <Route path="team" element={<Navigate to="/app/buyers" replace />} />
                    <Route path="*" element={<Navigate to="/app" replace />} />
                  </Routes>
                </AppShell>
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
